import axios from 'axios'
import Cookies from 'js-cookie'
let token = window.localStorage.getItem("token");

const headers = {
  'Content-Type': 'application/json',
}
if (token !== null && token !== undefined && token !== "null" && token !== "undefined") {
  console.log("active token found", typeof token, token == undefined)
  headers['Authorization'] = `Token ${token}`
}
const cookie = Cookies.get('csrftoken')
if (cookie) {
  headers['X-CSRFToken'] = cookie
}

export const setToken = (newToken) => {
  if (newToken) {
    localStorage.setItem("token", newToken)
    token = newToken
    api.defaults.headers.common["Authorization"] = `Token ${newToken}`
    console.log("new token", token, localStorage.getItem("token"))
  }
}
console.log("headers", headers)

const api =  axios.create({
  baseURL: '/api',
  timeout: 5000,
  headers
})
export default api;